import React, { useEffect, useMemo, useState } from "react";

const addMeta = (name, content) => {
  let meta = document.createElement("meta");
  meta.content = content;
  meta.name = name;
  document.getElementsByTagName("head")[0].appendChild(meta);
};
const removeMeta = (name, content) => {
  let meta = document.getElementsByTagName("meta")[name].getAttribute(content);

  document.getElementsByTagName("head")[0].removeChild(meta);
};

export const RouterGuard = ({ mobileMeta, isMobile, children }) => {
  useEffect(() => {
    let viewport = document.querySelector("meta[name=viewport]");
    if (!viewport) {
      // in case there is no view port meta tag creates one and add it to the head
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.getElementsByTagName("head")[0].appendChild(viewport);
    }

    const content = mobileMeta
      ? "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0,user-scalable=no"
      : "width=1400";

    viewport.setAttribute("content", content);
  }, [isMobile, mobileMeta]);

  return <div id={mobileMeta ? "mobile" : ""}>{children}</div>;
};
